export function hasSelfReflectionScore(score) {
  return score !== null && score !== undefined && score !== '' && Number.isFinite(Number(score));
}

export function getSelfReflectionAssessmentStatus(subject, now = new Date()) {
  if (!subject || subject.assessmentStatus === 'none' || !subject.lastAssessedAt) {
    return { label: 'Noch keine Eingabe', color: 'default' };
  }

  const lastAssessedAt = new Date(subject.lastAssessedAt);
  const oneYearAgo = new Date(now);
  oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
  if (!Number.isNaN(lastAssessedAt.getTime()) && lastAssessedAt < oneYearAgo) {
    return { label: 'Letzte Einschätzung > 1 Jahr', color: 'warning' };
  }

  return { label: 'Einschätzung erfolgt', color: 'success' };
}